import { keepPreviousData } from '@tanstack/react-query';
import { noddiAsync, URLKeys } from 'noddi-async';
import type { NoddiPaginationState } from 'noddi-ui-web';

/**
 * One page of the group's members. Shared by the member table, the car sheet's driver
 * picker and the member sheet, so a sheet reads its row back from the page it came from.
 */
export const useNotificationOverviewMembers = (userGroupId: number, pagination: NoddiPaginationState, enabled = true) =>
  noddiAsync.useGet({
    type: URLKeys.getPaginatedNotificationOverviewMembers,
    input: { userGroupId, ...pagination },
    queryConfig: { placeholderData: keepPreviousData, enabled }
  });
